import React, { useState, useCallback, useEffect } from "react";
import { useStore } from "stores/connect";
import UploadField from "./UploadField";
import UploadFieldStore, { UploadFieldActions } from "./UploadFieldStore";
const UploadFieldContainer = ({
  enableRemoval = false,
  fileId = void 0,
  onUpdate,
  accept = void 0,
  setDisableFormSubmission
}) => {
  const [isLoading, setIsLoading] = useState(!!fileId);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadConfig, setUploadConfig] = useState();
  const [uploadSuccessful, setUploadSuccessful] = useState();
  const [currentFile, setCurrentFile] = useState();
  useStore(UploadFieldStore);
  useEffect(() => {
    if (!fileId || !isLoading) {
      return;
    }
    UploadFieldActions.get(fileId).then((response) => {
      setCurrentFile({
        id: fileId,
        name: response.file_name
      });
    }).finally(() => {
      setIsLoading(false);
    });
  }, [fileId, isLoading]);
  useEffect(() => {
    UploadFieldActions.getConfig().then((response) => {
      setUploadConfig({
        maxUploadSize: response.max_file_size_bytes
      });
    });
  }, []);
  const onDeleteFile = useCallback(() => {
    setCurrentFile(void 0);
    onUpdate(void 0);
  }, [onUpdate]);
  const onUploadFile = useCallback(
    (files) => {
      if (currentFile) {
        onDeleteFile();
      }
      setIsUploading(true);
      setDisableFormSubmission(true);
      UploadFieldActions.upload(files[0]).then((response) => {
        const { id, file_name: name } = response;
        setCurrentFile({
          id,
          name
        });
        onUpdate(id);
        setUploadSuccessful(true);
      }).catch(() => {
        setUploadSuccessful(false);
      }).finally(() => {
        setIsUploading(false);
        setDisableFormSubmission(false);
      });
    },
    [currentFile, onDeleteFile, onUpdate, setDisableFormSubmission]
  );
  return /* @__PURE__ */ React.createElement(
    UploadField,
    {
      accept,
      uploadSuccessful,
      currentFile,
      enableRemoval,
      isLoading,
      isUploading,
      uploadConfig,
      onUploadFile,
      onDeleteFile
    }
  );
};
export default UploadFieldContainer;
